import axios from 'axios';
import { config } from '../config/environment';
import { ErrorToast } from '@/SharedComponents/Toaster/toast';
import { showLoader, hideLoader } from '../Components/Loader/LoaderService';

let activeRequests = 0;
let loaderTimeout = null;
let isNetworkError = false;

const startLoader = () => {
  if (activeRequests === 0) {
    loaderTimeout = setTimeout(() => {
      showLoader();
    }, 300);
  }
  activeRequests++;
};

const stopLoader = () => {
  activeRequests--;
  if (activeRequests === 0) {
    clearTimeout(loaderTimeout);
    hideLoader();
  }
};

class BaseHttpService {
  constructor() {
    this.http = axios.create({
      baseURL: config.ROOT_URL,
      headers: { 'Content-Type': 'application/json' },
    });

    this.http.interceptors.request.use(
      (request) => {
        startLoader();
        const token = localStorage.getItem('token');
        if (token) request.headers.Authorization = `Bearer ${token}`;
        return request;
      },
      (error) => {
        stopLoader();
        return Promise.reject(error);
      }
    );

    this.http.interceptors.response.use(
      (res) => {
        stopLoader();
        if (res.status < 200 || res.status >= 300) {
          const message = res.data?.message || `Unexpected response: ${res.status}`;
          ErrorToast('Error!', message);
          return Promise.reject(res);
        }
        return res.data;
      },
      (err) => {
        stopLoader();
        console.log('coming here', err);
        // If skipErrorToast flag is set, don't show toast 
        if (err.config && err.config.skipErrorToast) return Promise.reject(err);

        if (!err.response) {
          if (!isNetworkError) {
            isNetworkError = true;
            ErrorToast(
              'Error!',
              'Looks like the server is taking to long to respond, this can be caused by either poor connectivity or an error with our servers. Please try again in a while'
            );
            setTimeout(() => {
              isNetworkError = false;
            }, 5000);
          }
          return Promise.reject(err);
        }

        const status = err?.response?.status;

        // if (status === 401) {
        //   window.location.href = '/error/403';
        //   return;
        // }
        // if (status === 500 || !err.response) {
        //   window.location.href = '/error/503';
        //   return;
        // }

        const message =
          err.response?.data?.message ||
          err.response?.statusText ||
          err.message ||
          'Something went wrong!';
        ErrorToast('Error!', message);
        console.error('API Error:', message);

        return Promise.reject(err);
      }
    );
  }

  getAll(url, params = {}, options = {}) {
    return this.http.get(url, {
      params,
      ...options, // REQUIRED
    });
  }

  getExport(url, params = {}) {
    return this.http.get(url, { params, responseType: 'blob' });
  }

  getByID(url, id) {
    return this.http.get(`${url}/${id}`);
  }

  delete(url) {
    return this.http.delete(url);
  }

  post(url, data) {
    return this.http.post(url, data);
  }

  fileUpload(url, data) {
    return this.http.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data', // override only Content-Type
      },
    });
  }

  put(url, data) {
    return this.http.put(url, data);
  }

  patch(url, data) {
    return this.http.patch(url, data);
  }

  saveByID(url, id, data) {
    return this.http.patch(`${url}/${id}`, data);
  }

  getExternal(url) {
    return axios.get(url);
  }
}

export default new BaseHttpService();
